module.exports = __webpack_public_path__ + "img/causa-roupa.29278664.jpeg";